import webDev from '../assets/images/webdev.jpg';
import dMarket from '../assets/images/dmarket.jpg';
import dliteracy from '../assets/images/dliteracy.jpg';
import ui from '../assets/images/ui.jpg';
import gdesign from '../assets/images/gdesign.jpg';
import it from '../assets/images/it.jpg';
import se from '../assets/images/se.jpg';
import mapp from '../assets/images/mapp.jpg';
import cp from '../assets/images/cp.jpg'
import db from '../assets/images/911.jpg';
import csecurity from '../assets/images/csecurity.jpg';
import ai from '../assets/images/ai.jpg';
import pmanage from '../assets/images/pmanage.jpg';
import pmanagement from '../assets/images/pmanagement.jpg';
import pvgraphy from '../assets/images/pvgrapghy.jpg';
import blockchain from '../assets/images/442.jpg';
import sa from '../assets/images/sa.jpg';
import entre from '../assets/images/entre.jpg';
import ad from '../assets/images/ad.jpg';
import backendEngineering from '../assets/images/backendpython.jpg';
import dataEngineering from '../assets/images/dataengin.png';
import dataScience from '../assets/images/datascience.jpg';
import productMarketing from '../assets/images/productmarketing.jpg';
import technicalWriting from '../assets/images/techwriter.jpg';
import cloudEngineering from '../assets/images/cloud.jpeg';
import qualityAssurance from '../assets/images/testing.jpg';
import devOps from '../assets/images/devops.jpg';
import aiAutomation from '../assets/images/AI-n8n.png';
import frontend from '../assets/images/front-end.jpg';
import ai_ml_advanced from '../assets/images/ai_ml_advanced.png'

let courses = [{
  id: 1,
  name: "Fundamental Digital Literacy",
  slug: "fundamental_digital_literacy",
  duration: "6 weeks",
  fee: "N45,000",
  curriculum: ["Introduction to Computer", "Computer Appreciation", "Fundamentals of PC and operations", "Typing Tutorial", "Word Processing", "Internship"],
  img: dliteracy,
  alt: "Learn at Abia Tech Hub - Fundamental Digital Literacy",
  description: "This basic course introduces the digital world and the skills necessary to excel in society. It introduces digital technologies like the internet, social media and mobile devices and how to use them to find, create, evaluate and communicate information.",
  price: 45000,
},
{
  id: 2,
  name: "Fullstack Web development",
  slug: "fullstack_web_development",
  duration: "12 weeks",
  fee: "N170,000",
  curriculum: ["Fundamentals of Web Development", "Hypertext Markup Language", "Cascading Style Sheet", "JavaScript", "Github", "React JS", "Frontend Project", "web server", "Python", "PHP", "SQL", "MONGODB", "Tooling and Setup", "Fullstack Project and Capstone", "Internship"],
  img: webDev,
  alt: "Learn at Abia Tech Hub - Fullstack Web development",
  description: "Being one of the most sought-after specialties, this course teaches how to build fully functional and responsive websites and web applications using different programming languages. It explores the fundamentals of web development up to the application of advanced web development frameworks.",
  price: 170000,
  downloadable: true,
  pdfUrl: "/Pdfurls/Full_Stack_Development.pdf",
},
{
  id: 3,
  name: "Advanced Graphic Design",
  slug: "advanced_graphic_design",
  duration: "12 weeks",
  fee: "N140,000",
  curriculum: ["Graphics Design Basics", "Basic Rules", "Color Theory", "Typography", "Layout", "Composition", "Branding", "Logo Design", "Modern Trends", "The Business of Design", "Internship"],
  img: gdesign,
  alt: "Learn at Abia Tech Hub - Advanced Graphic Design",
  description: "Learn how to create visual content that communicates to your audience and presents aesthetically pleasing designs in this intensive course using powerful design tools like Adobe Photoshop and Adobe Illustrator.",
  price: 140000,
},
{
  id: 4,
  name: "UI/UX Design",
  slug: "UI_UX_design",
  duration: "12 weeks",
  fee: "N130,000",
  curriculum: ["Introduction to UI Design", "Introduction to UX Design", "User Research", "Information Architecture", "Interaction Design", "Prototyping Tools", "Visual Design Principles", "Portfolio Development", "UI/UX Design Capstone", "Internship"],
  img: ui,
  alt: "Learn at Abia Tech Hub - UI/UX Design",
  description: "This 2-in-in course teaches people how to build interfaces and visuals that aids user interaction with a product. It also extends to assessing or brainstorming over the user's interaction to further improve the product.",
  price: 130000,
  downloadable: true,
  pdfUrl: "/Pdfurls/UI_UX Design",
},
{
  id: 5,
  name: "Data Analysis / Visualization",
  slug: "data_analysis_and_visualization",
  duration: "12 weeks",
  fee: "N150,000",
  curriculum: ["Introduction to Data Analytics", "Statistics", "Understanding Data", "Microsoft Excel for data analytics", "SQL for Data Analytics", "Power BI for Business Intelligence", "Python for Data Analytics", "Capstone Project and Internship", "Internship"],
  img: ui,
  alt: "Learn at Abia Tech Hub - Data Analysis / Visualization",
  description: "This curriculum covers 3 months of teaching guidelines, 3 days per week, and 1 month of internship. It runs from basic and intermediate classes to advanced classes.",
  price: 150000,
  downloadable: true,
  pdfUrl: "/Pdfurls/Data_Analysis_Visualiuzation",
},
{
  id: 6,
  name: "Digital Marketing",
  slug: "digital_marketing",
  duration: "12 weeks",
  fee: "N120,000",
  curriculum: ["Introduction", "Search Engine Optimization", "Google Ads – Search & Display Advertising Campaigns", "Google My Business", "Content Marketing", "Social Media Marketing", "Social Media Advertising", "Google Analytics", "Internship"],
  img: dMarket,
  alt: "Learn at Abia Tech Hub - Digital Marketing",
  description: "This specialty surrounds using the internet and digital technologies to communicate to potential customers of a brand, product or service.",
  price: 120000,
},
{
  id: 7,
  name: "Diploma in Information Technology",
  slug: "diploma_in_information_technology",
  duration: "10 weeks",
  fee: "N100,000",
  curriculum: ["Microsoft Office Suite", "Desktop Publishing", "Basic Graphics (Corel Draw and Adobe Photoshop)", "Office Automation", "Internet and E-mail", "Blogging", "Internship"],
  img: it,
  alt: "Learn at Abia Tech Hub - Diploma in Information Technology",
  description: "This diploma-level course intends to provide students with a wide range of technical and technological knowledge. It teaches how to use use computers to manipulate data in various ways.",
  price: 100000,
},
{
  id: 8,
  name: "Software Engineering",
  slug: "software_engineering",
  duration: "12 weeks",
  fee: "N200,000",
  curriculum: ["General Introduction", "Software Evolution", "Software Development Lifecycles", "Software Project Management and Methodologies", "Software Design and Analysis tools", "Software Implementation Software Testing and Maintenance", "DevOps CI/CD", "Internship"],
  img: se,
  alt: "Learn at Abia Tech Hub - Software Engineering",
  description: "In this course, students learn how the concepts and processes of designing, developing and maintaining functional software.",
  price: 200000,
},
{
  id: 9,
  name: "Mobile App Development",
  slug: "mobile_app_development",
  duration: "12 weeks",
  fee: "N180,000",
  curriculum: ["User Interactions", "Simple User Interface", "Dart", "Flutter", "React Native", "Internship"],
  img: mapp,
  alt: "Learn at Abia Tech Hub - Mobile App Development",
  description: "Mobile App Development is an intensive course that guides through developing mobile apps for mobile devices",
  price: 180000,
},
{
  id: 10,
  name: "Computer Programming",
  slug: "computer_programming",
  duration: "12 weeks",
  fee: "N110,000",
  curriculum: ["Introduction", "Data and Control Structures", "Analytical Thinking/Problem solving", "Algorithm development and design patterns", "Language Selection and Specialization", "Internship"],
  img: cp,
  alt: "Learn at Abia Tech Hub - Computer Programming",
  description: "This course teaches students how to write codes that instruct computers on what tasks to perform and how to perform them. This also covers the concepts of Data Structures, Algorithms and Design patterns.",
  price: 110000,
},
{
  id: 11,
  name: "Database Management",
  slug: "database_management",
  duration: "6 weeks",
  fee: "N100,000",
  curriculum: ["Introduction", "Fundamental Database Concepts", "SQL", "Oracle", "MongoDB", "Internship"],
  img: db,
  alt: "Learn at Abia Tech Hub - Database Management",
  description: "Explore the creation, organization, storage, retrieval and manipulation of data using Database Management Systems in this intensive course. ",
  price: 100000,
},
{
  id: 12,
  name: "Cyber Security",
  slug: "cyber_security",
  duration: "12 weeks",
  fee: "N180,000",
  curriculum: ["Cybersecurity Fundamentals", "Basic Networking Concepts", "Operating Systems and Security", "Introduction to Python", "Cybersecurity Frameworks and Standards", "Information Security Policies and Procedures", "Threats and Vulnerabilities", "Network Security", "Access Control and Authentication", "Security Monitoring and Incident Response", "Encryption and Cryptography", "Web Security", "Ethical Hacking and Penetration Testing", "Social Engineering and Phishing", "Exploitation and Post-Exploitation", "Cybersecurity Tools", "Capstone: Cybersecurity Hands on", "Internship"],
  img: csecurity,
  alt: "Learn at Abia Tech Hub - Cyber Security",
  description: "This course is designed to guide participants on how to protect data and systems against malicious activities. It also teaches how to analyze and detect vulnerabilities in an application or system that can be exploited by an attacker and counter such attacks.",
  price: 180000,
  downloadable: true,
  pdfUrl: "/Pdfurls/Cyber_Security",
},
{
  id: 13,
  name: "Artificial Intelligence and Machine Learning",
  slug: "artificial_intelligence_and_machine_learning",
  duration: "12 weeks",
  fee: "N250,000",
  curriculum: ["History and foundations of AI", "Problem-solving by Search", "Introduction to Machine Learning", "Natural Language Processing", "Knowledge and Reasoning", "Internship"],
  img: ai,
  alt: "Learn at Abia Tech Hub - Artificial Intelligence and Machine Learning",
  description: "Artificial Intelligence uses sets of algorithms to train machines to learn from and mimic human intelligence. This course covers the concepts of AI and Machine Learning.",
  price: 250000,
},
{
  id: 14,
  name: "System Administration",
  slug: "system_administration",
  duration: "6 weeks",
  fee: "N120,000",
  curriculum: ["Research and Documentation Writing", "Installing and managing software", "Scripting and Intro to Automation", "Local and Network Security", "Protocols Powering the internet", "Internship"],
  img: sa,
  alt: "Learn at Abia Tech Hub - System Administration",
  description: "This field is responsible for managing the upkeep, configuration, and reliable operation of multi-user computer systems such as servers and databases. It also involves planning and properly responding to system outages and various other problems.",
  price: 120000,
},
{
  id: 15,
  name: "Blockchain DApp Development",
  slug: "blockchain_development",
  duration: "12 weeks",
  fee: "N290,000",
  curriculum: ["Need for Blockchain", "Blockchain Development", "Understanding Different Programming Languages", "Internship"],
  img: blockchain,
  alt: "Learn at Abia Tech Hub - Blockchain DApp Development",
  description: "In this course you learn the processes of building decentralized applications with backend code running on a decentralized peer-to-peer network. ",
  price: 290000,
},
{
  id: 16,
  name: "Photography & Videography",
  slug: "photography_and_videography",
  duration: "12 weeks",
  fee: "N180,000",
  curriculum: ["Introduction", "Equipment handling", "Shot Composition", "Shutter speed, white balance and ISO", "Lighting equipment", "Sound Recording", "Different types of edits", "Color Correction", "Sound and image synchronization", "Script Writing", "Internship"],
  img: pvgraphy,
  alt: "Learn at Abia Tech Hub - Photography & Videography",
  description: "This course is designed to bestow in depth  knowledge on basic camera functions, filters, flash and how images are affected by light.  We also teach fundamentals of videography, how to capture moving pictures and sound using digital video and audio equipment, coupled with lighting, composition, framing, and editing expertise.",
  price: 180000,
},
{
  id: 17,
  name: "Project Management",
  slug: "project_management",
  duration: "6 weeks",
  fee: "N100,000",
  curriculum: ["Introduction", "Planning Your Project", "Implementing Your Project", "Project Management Techniques", "Business and Financial Issues", "Career in Project Management", "Internship"],
  img: pmanage,
  alt: "Learn at Abia Tech Hub - Project Management",
  description: "In this course, you are trained on how to apply certain processes and methods, bestowed with skills and knowledge to achieve specific project objectives. We also equip you with excellent communication skills as Successful project managers should be detail-oriented and have excellent communication skills.",
  price: 100000,
},
{
  id: 18,
  name: "Architechural Design(2D/3D)",
  slug: "architechural_design",
  duration: "12 weeks",
  fee: "N180,000",
  curriculum: ["Understanding Architectural basics", "Creating basic interior scene", "Using utilities for efficient production", "Building a mini project", "Internship"],
  img: ad,
  alt: "Learn at Abia Tech Hub - Architechural Design(2D/3D)",
  description: "This course is designed to Develop your basic design literacy and teaches basic methods of solving architectural  problems and skills in preparation for tackling complex design problems in architecture. Also in this course, students are introduced to a basic vocabulary of three-dimensional form making, space making and they learn to solve simple design problems systematically, with creativity and imagination.",
  price: 180000,
},
{
  id: 19,
  name: "Entrepreneurship Masterclass",
  slug: "entrepreneurship_masterclass",
  duration: "12 weeks",
  fee: "N170,000",
  curriculum: ["Turning ideas into products", "Figuring out the right business model", "Fundamentals of growth and sales", "Incorporating your company", "Everything you need to know about fundraising", "Becoming a leader", "The perfect business pitch", "Building great teams", "Internship"],
  img: entre,
  alt: "Learn at Abia Tech Hub - Entrepreneurship Masterclass",
  description: "This class helps you develop the knowledge, skills and mindset to thrive in an entrepreneurial environment. In this course, you will learn essential business fields such as finance, sales, marketing, versatility. This entrepreneurship course  will teach you how to cultivate a growth-oriented mindset to thrive in business.",
  price: 170000,
},
{
  id: 20,
  name: "Product Management",
  slug: "product_management",
  duration: "6 weeks",
  fee: "N150,000",
  curriculum: ["Introduction to Product Management", "Understanding the Market", "Product Strategy and Vision", "Product Development and Execution", "Launching and Managing Products", "Business and Financial Aspects", "Career in Product Management", "Internship"],
  img: pmanagement,
  alt: "Learn at Abia Tech Hub - Product Management",
  description: "In this course, you will learn how to effectively oversee the lifecycle of a product, from ideation to market launch and beyond. You'll acquire skills in defining a product vision, conducting market research, managing stakeholders, and ensuring that the product meets customer needs. The course also focuses on developing leadership and strategic thinking, essential for a successful career in product management.",
  price: 150000,
},

//  Data Science
{
  id: 21,
  name: "Data Science",
  slug: "data_science",
  duration: "12 weeks",
  fee: "N175,000",
  curriculum: [
    "Introduction to Data Science",
    "Python & R Programming Fundamentals",
    "Data Wrangling and Cleaning",
    "Data Visualization Techniques",
    "Statistical Analysis and Inference",
    "Exploratory Data Analysis",
    "Introduction to Machine Learning",
    "Supervised and Unsupervised Learning",
    "Model Evaluation and Validation",
    "SQL and Database Integration",
    "Working with Big Data and Cloud Tools",
    "Capstone Project: Predictive Analytics Application"
  ],
  img: dataScience,
  alt: "Learn at Abia Tech Hub - Data Science",
  description: "In this course, you will master the skills to analyze large datasets, build predictive models, and derive actionable insights. Learn Python, R, SQL, and machine learning techniques to solve real-world problems. The course culminates in a Capstone Project involving predictive analytics.",
  price: 175000
},

// 2. Data Engineering
{
  id: 22,
  name: "Data Engineering",
  slug: "data_engineering",
  duration: "12 weeks",
  fee: "N154,000",
  curriculum: [
    "Introduction to Data Engineering",
    "Python for Data Engineering",
    "SQL and Database Management",
    "ETL Concepts and Pipelines",
    "Data Warehousing and Big Data",
    "Apache Spark Fundamentals",
    "Cloud Data Engineering (AWS/GCP)",
    "Data Modeling and Architecture",
    "Data Quality and Governance",
    "Performance Optimization",
    "Automation and Workflow Orchestration",
    "Capstone Project: End-to-End Data Pipeline"
  ],
  img: dataEngineering,
  alt: "Learn at Abia Tech Hub - Data Engineering",
  description: "In this course, you will learn to build scalable and reliable data pipelines. Gain expertise in SQL, Python, Apache Spark, and cloud data platforms to prepare data for analysis. Complete the course with a Capstone Project building an end-to-end data pipeline.",
  price: 154000
},

// 3. Backend Engineering (Python)
{
  id: 23,
  name: "Backend Engineering (Python)",
  slug: "backend_engineering_python",
  duration: "12 weeks",
  fee: "N140,000",
  curriculum: [
    "Introduction to Backend Development & Python Fundamentals",
    "HTTP, APIs, and Web Frameworks Overview",
    "Databases and ORM Concepts",
    "Building RESTful APIs with Flask and FastAPI",
    "Authentication and Authorization",
    "Middleware, Caching, and Performance Optimization",
    "Working with Asynchronous Programming",
    "File Handling, Media, and Background Tasks",
    "Testing and Debugging",
    "Docker and Containerization",
    "Deployment and Cloud Infrastructure",
    "Capstone Project: ServiceHub API Platform"
  ],
  img: backendEngineering,
  alt: "Learn at Abia Tech Hub - Backend Engineering (Python)",
  description: "In this course, you will learn to design and develop robust server-side applications using Python. Gain expertise in APIs, databases, authentication, deployment, and modern frameworks such as Django, Flask, and FastAPI. The course prepares you for real-world backend projects, including a Capstone Project involving a fully functional API platform.",
  price: 140000
},

// 4. Product Marketing
{
  id: 24,
  name: "Product Marketing",
  slug: "product_marketing",
  duration: "10 weeks",
  fee: "N105,000",
  curriculum: [
    "Introduction to Product Marketing",
    "Market Research & Customer Insights",
    "Competitive Analysis & Market Segmentation",
    "Product Positioning & Messaging",
    "Branding and Communication Strategies",
    "Go-To-Market (GTM) Strategy",
    "Marketing Channels and Campaigns",
    "Analytics and Performance Measurement",
    "Product Marketing Tools & Automation",
    "Capstone Project: Launch Plan for a New Product"
  ],
  img: productMarketing,
  alt: "Learn at Abia Tech Hub - Product Marketing",
  description: "In this course, you will learn to connect products to market needs through research, positioning, and go-to-market strategies. Gain practical skills in messaging, campaign management, and analytics. Complete the course with a Capstone Project designing a product launch plan.",
  price: 105000
},

// 5. Technical Writing
{
  id: 25,
  name: "Technical Writing",
  slug: "technical_writing",
  duration: "10 weeks",
  fee: "N84,000",
  curriculum: [
    "Introduction to Technical Writing",
    "Audience Analysis and Document Planning",
    "Writing Fundamentals",
    "Technical Documentation Tools",
    "API and Software Documentation",
    "User Manuals and Guides",
    "Editing and Proofreading",
    "Advanced Documentation Techniques",
    "Collaboration and Project Management",
    "Capstone Project: Complete Documentation for a Sample Software Application"
  ],
  img: technicalWriting,
  alt: "Learn at Abia Tech Hub - Technical Writing",
  description: "In this course, you will develop skills to create clear, structured, and professional technical documents. Learn to write user manuals, API docs, tutorials, and white papers, using industry-standard tools and best practices. The course includes a Capstone Project producing a full documentation set for a software application.",
  price: 84000
},

// 6. Cloud Engineering
{
  id: 26,
  name: "Cloud Engineering",
  slug: "cloud_engineering",
  duration: "12 weeks",
  fee: "N161,000",
  curriculum: [
    "Introduction to Cloud Computing",
    "Cloud Architecture and Virtualization Concepts",
    "Networking and Security Fundamentals",
    "Cloud Storage and Databases",
    "Compute and Application Services",
    "Infrastructure as Code (IaC)",
    "Configuration Management and Automation",
    "Containers and Orchestration (Docker & Kubernetes)",
    "CI/CD Pipelines and DevOps Integration",
    "Monitoring, Logging, and Optimization",
    "Cloud Security and Compliance",
    "Capstone Project: Cloud-Based Infrastructure Automation and Deployment"
  ],
  img: cloudEngineering,
  alt: "Learn at Abia Tech Hub - Cloud Engineering",
  description: "In this course, you will gain hands-on experience designing, deploying, and managing cloud infrastructure using AWS, Azure, or GCP. Learn automation, containerization, CI/CD, and monitoring practices. Complete the course with a Capstone Project building a cloud-based infrastructure solution.",
  price: 161000
},

// 7. Quality Assurance (QA)
{
  id: 27,
  name: "Quality Assurance (QA)",
  slug: "quality_assurance",
  duration: "12 weeks",
  fee: "N126,000",
  curriculum: [
    "Introduction to Quality Assurance",
    "Testing Methodologies",
    "Test Planning and Documentation",
    "Bug Tracking and Defect Management",
    "Functional Testing",
    "Automated Testing Fundamentals",
    "Performance and Load Testing",
    "Security and Compliance Testing",
    "Agile QA and Continuous Testing",
    "Mobile and API Testing",
    "Advanced Test Automation and Tools",
    "Capstone Project: End-to-End QA Suite for a Web Application"
  ],
  img: qualityAssurance,
  alt: "Learn at Abia Tech Hub - Quality Assurance",
  description: "In this course, you will learn how to ensure software quality through manual and automated testing. Gain expertise in test planning, execution, performance, security, and QA tools. Complete the course with a Capstone Project developing a comprehensive QA suite for a web application.",
  price: 126000
},

// 8. DevOps (Development & Operations)
{
  id: 28,
  name: "DevOps (Development & Operations)",
  slug: "devops",
  duration: "12 weeks",
  fee: "N168,000",
  curriculum: [
    "Introduction to DevOps",
    "Version Control and Git",
    "Continuous Integration (CI)",
    "Continuous Deployment (CD)",
    "Infrastructure as Code (IaC)",
    "Configuration Management",
    "Containerization with Docker",
    "Container Orchestration with Kubernetes",
    "Monitoring and Logging",
    "CI/CD Integration with Cloud Platforms",
    "Security in DevOps",
    "Capstone Project: End-to-End DevOps Pipeline for a Web Application"
  ],
  img: devOps,
  alt: "Learn at Abia Tech Hub - DevOps",
  description: "In this course, you will learn how to bridge development and operations using DevOps practices. Gain skills in CI/CD, containerization, infrastructure automation, monitoring, and cloud deployment. The course culminates in a Capstone Project implementing a full DevOps pipeline for a web application.",
  price: 168000
},

{
  id: 29,
  name: "AI Automation with n8n",
  slug: "ai-automation-n8n",
  duration: "10 weeks",
  fee: "N180,000",
  curriculum: [
    "Introduction to AI Automation",
    "Overview of n8n and Workflow Automation",
    "Setting Up n8n (Local & Cloud)",
    "Understanding Nodes, Triggers, and Workflows",
    "API Integration and Webhooks",
    "Working with Databases and Spreadsheets",
    "Automating AI Tasks with OpenAI & Other LLMs",
    "Building Chatbots and AI Assistants",
    "Email, CRM, and Marketing Automation",
    "Error Handling, Logging, and Workflow Optimization",
    "Security and Best Practices in Automation",
    "Capstone Project: Building an End-to-End AI Automation System with n8n"
  ],
  img: aiAutomation,
  alt: "Learn at Abia Tech Hub - AI Automation with n8n",
  description: "This course teaches you how to build intelligent automation workflows using n8n and AI tools. You will learn how to automate business processes, integrate APIs, connect AI models, and deploy scalable workflows. By the end of the course, you will complete a capstone project that demonstrates a real-world AI-powered automation system.",
  price: 180000
},

{
  id: 30,
  name: "Frontend Web Development",
  slug: "frontend-web-development",
  duration: "12 weeks",
  fee: "N110,500",
  curriculum: [
    "Introduction to Web Development",
    "HTML5 Fundamentals and Semantic Markup",
    "CSS3, Flexbox, and Grid Layout",
    "Responsive Web Design and Mobile-First Approach",
    "JavaScript Fundamentals (ES6+)",
    "DOM Manipulation and Events",
    "Version Control with Git and GitHub",
    "Frontend Framework Basics (React)",
    "State Management and Component Reusability",
    "Working with APIs and JSON",
    "Performance Optimization and Best Practices",
    "Capstone Project: Building a Responsive Frontend Web Application"
  ],
  img: frontend,
  alt: "Learn at Abia Tech Hub - Frontend Web Development",
  description: "This course equips you with the skills needed to design and build modern, responsive, and user-friendly websites. You will learn HTML, CSS, JavaScript, and React to create interactive web interfaces. The course concludes with a capstone project where you will build a fully responsive frontend web application.",
  price: 110500
},

{
  id: 31,
  name: "Advanced Artificial Intelligence & Machine Learning",
  slug: "advanced-artificial-intelligence-and-machine-learning",
  duration: "16 weeks",
  fee: "N180,000",
  curriculum: [
    "Advanced Machine Learning Algorithms",
    "Feature Engineering and Model Optimization",
    "Ensemble Learning (Random Forest, XGBoost, Gradient Boosting)",
    "Deep Learning Fundamentals and Neural Networks",
    "Convolutional Neural Networks (CNNs)",
    "Recurrent Neural Networks (RNNs, LSTM, GRU)",
    "Advanced Natural Language Processing (NLP)",
    "Transformers and Introduction to Large Language Models (LLMs)",
    "Computer Vision and Image Processing",
    "Object Detection and Face Recognition",
    "Reinforcement Learning Concepts and Applications",
    "Model Deployment with Flask and FastAPI",
    "MLOps Fundamentals and Model Monitoring",
    "AI Ethics and Responsible AI",
    "Real-World Industry Projects",
    "Capstone Project: End-to-End AI Solution Development",
    "Advanced Internship"
  ],
  img: ai_ml_advanced,
  alt: "Learn at Abia Tech Hub - Advanced Artificial Intelligence and Machine Learning",
  description: "This advanced course is designed for learners who already understand the fundamentals of AI and Machine Learning and want to build production-ready intelligent systems. You will gain hands-on experience with deep learning, NLP, computer vision, model deployment, and MLOps, culminating in a real-world capstone project and advanced internship experience.",
  price: 180000
}



];

const getCourses = () => {
  return (
    courses
  )
}

const getCourse = (courseSlug) => {
  return courses.find(
    course => course.slug === courseSlug
  )
}
const getCourseName = (cslug) => {
  return courses.find(
    course => course.name === cslug
  )
}

// Update prices and fees by 30%
courses.forEach(course => {
  course.price = Math.round(course.price * 1.60); // Increase price by 30%
  course.fee = `N${course.price.toLocaleString()}`; // Update fee string
});

console.log(courses); // Verify the updated courses


export { getCourses, getCourse, getCourseName };